import { render, staticRenderFns } from "./MainMenuControl.vue?vue&type=template&id=7b75c668&"
import script from "./MainMenuControl.vue?vue&type=script&lang=js&"
export * from "./MainMenuControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports